// A actions should export from here
// eslint-disable-next-line import/prefer-default-export
export { updateTheme } from './settingsAction';
export { fetchResources, updateReload } from './scheduleAction';
